import lightTheme from "./light"
import darkTheme from './dark'

export const themeOptions = [
    'light', 'dark', 'system'
]

const themes = {
    light: lightTheme,
    dark: darkTheme,
}

export default themes

